import { render, staticRenderFns } from "./TranslationEditModal.vue?vue&type=template&id=5c982615"
import script from "./TranslationEditModal.vue?vue&type=script&lang=ts"
export * from "./TranslationEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports